import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch,BrowserRouter as Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import ReduxToastr from 'react-redux-toastr';
import './styles/css/bootstrap.min.css';
import './styles/css/style.css';
import './styles/css/flags.css';
import './styles/css/font-awesome.css';
import { store,history } from './store/configureStore';
import App from './Container/App';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';

if (process.env.NODE_ENV !== "development")
    console.log = () => {};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </Router>
      <ReduxToastr
        timeOut={2000}
        position="top-center"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        getState={(state) => state.toastr} // This is the default
      />
    </Provider> 
  </React.StrictMode>, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
